import { render, staticRenderFns } from "./KpiLayoutOldVersion.vue?vue&type=template&id=0f7228c7&scoped=true&"
import script from "./KpiLayoutOldVersion.vue?vue&type=script&lang=js&"
export * from "./KpiLayoutOldVersion.vue?vue&type=script&lang=js&"
import style0 from "./KpiLayoutOldVersion.vue?vue&type=style&index=0&id=0f7228c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7228c7",
  null
  
)

export default component.exports